import FacebookImport from "./FacebookImport";
import UserProfile from "./UserProfile";
import Shares from "./shares";
import Auth from "./Auth";
export default [Auth, UserProfile, Shares, FacebookImport];
